import React, { Component, Fragment } from 'react';
import { compose } from 'recompose';
import { Trans } from 'react-i18next';
import { MutationFunction } from 'react-apollo';
import { Button, Grid } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { S3ObjectInput, UpdateUserProfileDocument } from 'api';
import { AspectRatios } from 'types/app';
import { IWithUser, withUser } from 'providers';
import { IUploader, UploadDialog, Uploader, UploadInput, UserAvatar } from 'components';

interface IPropsEnhanced extends IWithUser, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    uploadImage: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3),
    },
  });

const enhancers = compose<IPropsEnhanced, {}>(withUser, withStyles(styles));

class ImageUpload extends Component<IPropsEnhanced> {
  handleSave = (image: S3ObjectInput, updateUserProfile: MutationFunction) => {
    const { user } = this.props;

    const variables = {
      data: { id: user.id, image },
    };

    return updateUserProfile({ variables });
  };

  render() {
    const { classes, user } = this.props;

    return (
      <Grid container alignItems="center" className={classes.uploadImage}>
        <Grid item>
          <Uploader>
            {(uploaderProps: IUploader) => (
              <Fragment>
                <UploadInput onUpload={uploaderProps.onUpload}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <UserAvatar user={user} size={50} />
                    </Grid>
                    <Grid item xs>
                      <Button component="span">
                        <Trans i18nKey="user:uploadImage" />
                      </Button>
                    </Grid>
                  </Grid>
                </UploadInput>
                <UploadDialog
                  i18nKeyTitle="user:yourProfileImage"
                  i18nKeyReplace="components:replaceImage"
                  aspectRatio={AspectRatios.square}
                  mutation={UpdateUserProfileDocument}
                  onSave={this.handleSave}
                  {...uploaderProps}
                />
              </Fragment>
            )}
          </Uploader>
        </Grid>
      </Grid>
    );
  }
}

export default enhancers(ImageUpload);
